<template>
  <div
    class="input-group position-relative"
    :class="`input-group-${variant} ${getStatus(error, success)}`"
  >
    <textarea
      ref="textareaRef"
      :id="id"
      class="form-control"
      :rows="rows"
      :name="name"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="disabled"
      :readonly="readonly"
    ></textarea>
    
    <!-- Copy Button -->
    <button
      v-if="showCopyButton && modelValue"
      type="button"
      class="btn-copy"
      @click="copyToClipboard"
      :title="copied ? 'Đã copy!' : 'Copy nội dung'"
    >
      <i v-if="!copied" class="fas fa-copy"></i>
      <i v-else class="fas fa-check text-success"></i>
    </button>
  </div>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialTextarea",
  props: {
    variant: {
      type: String,
      default: "outline",
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Your text here...",
    },
    isRequired: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 5,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
    showCopyButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  mounted() {
    setMaterialInput();
  },
  methods: {
    getStatus: (error, success) => {
      let isValidValue;

      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }

      return isValidValue;
    },
    async copyToClipboard() {
      try {
        // Modern Clipboard API
        await navigator.clipboard.writeText(this.modelValue);
        this.showCopyFeedback();
      } catch (err) {
        // Fallback cho browsers cũ
        this.fallbackCopy();
      }
    },
    fallbackCopy() {
      const textarea = this.$refs.textareaRef;
      const wasReadonly = textarea.readOnly;
      
      // Tạm thời disable readonly để select được
      textarea.readOnly = false;
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      
      try {
        document.execCommand('copy');
        this.showCopyFeedback();
      } catch (err) {
        console.error('Copy failed:', err);
        this.$emit('copy-error', err);
      } finally {
        // Khôi phục readonly state
        textarea.readOnly = wasReadonly;
        // Bỏ selection
        window.getSelection().removeAllRanges();
      }
    },
    showCopyFeedback() {
      this.copied = true;
      this.$emit('copied', this.modelValue);
      
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}

.btn-copy {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  padding: 0;
  background: white;
  border: 1px solid #d2d6da;
  border-radius: 0.375rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-copy:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-copy:active {
  transform: scale(0.95);
}

.btn-copy i {
  font-size: 14px;
  color: #495057;
}

.btn-copy .text-success {
  color: #28a745 !important;
}

/* Thêm padding cho textarea khi có copy button */
.input-group:has(.btn-copy) .form-control {
  padding-right: 45px;
}

/* Style cho readonly */
.form-control[readonly] {
  background-color: #e9ecef;
  cursor: default;
}

.form-control[readonly]:focus {
  background-color: #e9ecef;
}
</style>